import { render, staticRenderFns } from "./StatusChangeMessageModal.vue?vue&type=template&id=d1dcac7a"
import script from "./StatusChangeMessageModal.vue?vue&type=script&lang=js"
export * from "./StatusChangeMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports